import { Injectable, inject } from '@angular/core';

import { Observable, combineLatest, map, startWith } from 'rxjs';
import { Store } from '@ngrx/store';

import { Category } from '@fcom/dapi/api/models/category';
import { FinnairServiceCatalogCampaign } from '@fcom/dapi/api/models/finnair-service-catalog-campaign';
import { LanguageService } from '@fcom/ui-translate';

import { CampaignTranslation } from '../modules/ancillaries/utils/ancillaries.utils';
import { CommonBookingFeatureState } from '../store/store.interface';
import { serviceCatalogCampaigns } from '../store/selectors/services.selector';

@Injectable()
export class CampaignService {
  private store$ = inject<Store<CommonBookingFeatureState>>(Store);
  private languageService = inject(LanguageService);

  private readonly rawCampaignTranslations$ =
    this.languageService.translate<Record<string, CampaignTranslation>>('campaign');

  readonly campaignTranslations$: Observable<Record<string, CampaignTranslation>> = this.rawCampaignTranslations$.pipe(
    startWith({} as Record<string, CampaignTranslation>)
  );

  getPersonalizedCampaignTag$(
    flightId: string,
    category: Category = Category.SEAT,
    travelerId?: string
  ): Observable<string | null> {
    return combineLatest([
      this.store$.pipe(serviceCatalogCampaigns(), startWith([] as FinnairServiceCatalogCampaign[])),
      this.rawCampaignTranslations$,
    ]).pipe(
      map(([campaigns, campaignTranslations]) => {
        const personalizedCampaign = campaigns.find((campaign) =>
          campaign.categories.some(
            (cat) =>
              cat.id === category &&
              !!cat.fragments[flightId] &&
              (!travelerId || cat.fragments[flightId].includes(travelerId))
          )
        );

        if (personalizedCampaign && campaignTranslations?.[personalizedCampaign.id]?.isPersonalized) {
          return campaignTranslations[personalizedCampaign.id].tag;
        }
        return null;
      })
    );
  }
}
